<template>
  <MaskLayer>
    <Slider class="w-25" @close="close">
      <!-- 內容 begin -->
      <div class="p-3 flex-grow-1 overflow-auto">
        <h6 class="mb-3">
          {{ $t('auth.userInvite.title') }}
        </h6>
        <div>
          <h6 class="mb-1 font-size-md d-flex align-items-center">
            <span class="ml-n1 text-danger">*</span>
            <span class="flex-grow-1">Email</span>
          </h6>
          <Labeling ref="labeling" v-bind="labelingOptions" add-button-text="＋" @change="onLabelsChange">
            <template v-slot:invalid-feedback>
              {{ $t('auth.userInvite.form.email.feedback.required') }}
            </template>
          </Labeling>
        </div>
        <div class="my-3">
          <h6 class="font-size-md">
            <span class="ml-n1 text-danger">*</span>
            <span class="flex-grow-1">{{ $t('auth.userInvite.form.role.label') }}</span>
          </h6>
          <b-form-group :state="roleState">
            <b-form-select
              v-model="roleId"
              :options="roles"
              size="sm"
              disabled-field="notEnabled"
              class="w-100 rounded-pill"
              :class="{ 'is-invalid': roleDirty && !roleId }"
              @input="onRoleChange"
            />
            <template v-slot:invalid-feedback>
              {{ $t('auth.userInvite.form.role.feedback.required') }}
            </template>
          </b-form-group>
          <div class="px-2 mx-3 my-3 text-primary border-left border-light">
            <template v-for="feature in features">
              <div :key="feature.id" class="font-size-sm mb-4">
                <h6 class="font-size-md mb-1">
                  {{ $t(`features.${feature.id}`) }}
                </h6>
                <ul v-if="feature.children && feature.children.length > 0" class="pl-4">
                  <template v-for="sub in feature.children">
                    <li :key="sub.id">
                      <b>{{ $t(`features.${sub.id}`) }}</b>
                    </li>
                  </template>
                </ul>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- 內容 end -->
      <!-- 置底按鈕 begin -->
      <FixedBottomBtn class="p-3">
        <div class="d-flex justify-content-end">
          <button class="ml-2 btn btn-sm btn-outline-light rounded-pill" @click="close">
            <span class="px-3 text-secondary">{{ $t('common.cancel') }}</span>
          </button>
          <button v-auth="['edit']" class="ml-2 btn btn-sm btn-success rounded-pill" @click="submit">
            <span class="px-3">{{ $t('auth.userInvite.form.send') }}</span>
          </button>
        </div>
      </FixedBottomBtn>
    </Slider>
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';
import Slider from '@/components/Slider.vue';
import Labeling from '@/components/Labeling.vue';
import FixedBottomBtn from '@/components/FixedBottomBtn.vue';
import PermissionService from '@/services/PermissionService';

export default {
  components: {
    MaskLayer,
    Slider,
    Labeling,
    FixedBottomBtn
  },
  data() {
    const vm = this;
    return {
      labelingOptions: {
        placeholder: 'name@company.com, ...',
        tagValidator: (tag) => {
          const reg = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
          return reg.test(tag);
        },
        validator: (tags) => tags.length > 0,
        invalidTagText: vm.$t('auth.userInvite.form.email.feedback.invalid')
      },
      emails: [],
      roleId: null,
      roleDirty: false,
      roles: [
        { value: null, text: vm.$t('auth.userInvite.form.role.placeholder'), notEnabled: true }
      ],
      features: [],
      alertShow: false
    };
  },
  computed: {
    roleState() {
      return this.roleDirty ? !!this.roleId : null;
    }
  },
  async created() {
    const result = await PermissionService.GetRolesAsync(null, 1000, 0);
    if (result && result.data) {
      this.roles = this.roles.concat(result.data.map((item) => ({ value: item.id, text: `${item.name}${item.desc ? `(${item.desc})` : ''}` })));
    }
  },
  methods: {
    // 角色選項變更事件
    async onRoleChange(roleId) {
      this.roleDirty = true;
      this.features = await PermissionService.GetRoleFeaturesAsync(roleId);
    },
    onLabelsChange(labels) {
      this.emails = labels;
    },
    // 驗證欄位
    validate() {
      let result = true;
      if (!this.$refs.labeling.validate()) {
        result = result && false;
      }

      this.roleDirty = true;
      if (!this.roleId) {
        result = result && false;
      }

      return result;
    },
    // 傳送
    async submit() {
      if (this.validate()) {
        try {
          await this.$loading(async () => {
            await PermissionService.SendInvitationAsync({ roleId: this.roleId, users: this.emails.map((mail) => ({ email: mail })) });
          });
          this.$notify.success(this.$t('auth.userInvite.form.sendSucceed'));
          this.$refs.labeling.initialize();
          this.confirm();
        } catch {
          this.$notify.danger(this.$t('auth.userInvite.form.sendFailed'));
        }
      }
    },
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
    }
  }
};
</script>
